"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reuse = void 0;
var actionFlowOverlays_1 = require("./actionFlowOverlays");
var reuseRaw = [
    {
        id: 52320010,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Available',
        caption: 'Available',
        showBodyInput: true,
        auditRow: { topicGroup: 'Available', taskGroup: 'Logistics', body: null, tagAux: null, value: null },
    },
    {
        id: 52320100,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Received',
        caption: 'Received',
        cssClass: 'asset-movement-in',
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Received',
            topicDetail: 'In Progress',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 52328100,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Surplus',
        caption: 'Surplus',
        cssStyle: { background: 'Yellow' },
        showBodyInput: true,
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Inventory',
            topicGroup: 'On Hand (Surplus)',
            topicDetail: 'In Progress',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 52330100,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Picking',
        caption: 'Picking',
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'ref',
        auditRow: {
            taskGroup: 'Inventory',
            topicGroup: 'Picking',
            topicDetail: 'Picking',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 52340100,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Order',
        caption: 'Order',
        cssStyle: { background: 'rgba(100,150,255,0.4)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'ref',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Task',
            topicDetail: 'In Progress',
            body: null,
            tagAux: null,
            value: null,
        },
    },
];
/** Configured: Logistics/Inventory → L — see actionFlowOverlays.ts */
exports.reuse = (0, actionFlowOverlays_1.configureReuseActions)(reuseRaw);
